import axios from "axios";
import { PuffLoader } from "react-spinners";

export const uploadImagePortfolio = async (file) => {
  const url = process.env.REACT_APP_CLOUDINARY_URL;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", "afriyofa");

  const { secure_url } = await axios
    .post(url, formData)
    .then((res) => res.data);
  return secure_url;
};

export const statsData = (totalPosts, pendingPosts, UnreadMessages) => {
  return [
    {
      id: 2,
      icon: { icon: "post", bgColor: "#5FC65F" },
      value: totalPosts,
      label: "Total Posts",
    },
    {
      id: 3,
      icon: { icon: "pending", bgColor: "#EAB313" },
      value: pendingPosts,
      label: "Pending Approval",
    },
    {
      id: 4,
      icon: { icon: "message", bgColor: "#A855F7" },
      value: UnreadMessages,
      label: "Unread Messages",
    },
  ];
};

const avatars = {
  user: (
    <i
      className="ri-user-line text-white text-xl"
      style={{ color: "white" }}
    ></i>
  ),
  post: (
    <i
      className="ri-article-line text-white text-xl"
      style={{ color: "white" }}
    ></i>
  ),
  message: (
    <i
      className="ri-mail-line text-white text-xl"
      style={{ color: "white" }}
    ></i>
  ),
  pending: (
    <i
      className="ri-time-line text-white text-xl"
      style={{ color: "white" }}
    ></i>
  ),
  approved: (
    <i className="ri-checkbox-circle-line" style={{ color: "white" }}></i>
  ),
};

export const statCard = ({ id, icon, value, label, change, changeType }) => {
  return (
    <div className="stat-card" key={id}>
      <div className="stat-header">
        <div className="stat-icon" style={{ backgroundColor: icon.bgColor }}>
          {avatars[icon.icon]}
        </div>
        <span className={`stat-change ${changeType}`}>{change}</span>
      </div>
      <div className="stat-value">
        {value}
        </div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

export const activityItem = ({ id, title, name }) => {
  let icon;
  let bgColor = "#5fc65fab";
  if (title === "New contact form submission received") {
    icon = avatars["message"];
  } else if (title === "Post submitted for review") {
    icon = avatars["post"];
  } else if (title === "Post approved and published") {
    icon = avatars["approved"];
  }

  return (
    <div className="activity-item" key={id}>
      <div className="activity-icon" style={{ backgroundColor: bgColor }}>
        {icon}
      </div>
      <div className="activity-content">
        <p className="activity-text">
          <span className="highlight">{title}</span>
          {name && `: ${name}`}
        </p>
        {/*  <p className="activity-time">{time}</p> */}
      </div>
    </div>
  );
};

//reusable section introduction title
export const adminSectionHeader = (title, details) => {
  return (
    <div className="dashboard-header">
      <h1>{title}</h1>
      <p>{details}</p>
    </div>
  );
};

//admin contents wrapper container

export default function AdminSectionsWrapper({ children }) {
  return <div style={{backgroundColor:"#F7F8FA", padding: "10px"}} className="section-wrapper-admin">{children}</div>;
}

export const loader = (height) => {
  return (
    <div
      style={{
        width: "100%",
        height: height || "100svh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <PuffLoader
        color="green"
        loading={true}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export const deletePost = async (postId) => {
  const api = process.env.REACT_APP_API_URL
  const url = `${api}/adm/post/delete/${postId}`
  console.log("Deleting post with ID (client):", url);
  try {
    await axios.post(url, { id: postId }, { withCredentials: true });
  } catch (err) {
    console.log("Error deleting post:", err);
    return;
  }
};
export const approvePost = async (postId) => {
  const api = process.env.REACT_APP_API_URL + "/adm/post/approve/" + postId;
  try {
    await axios.post(api, { id: postId }, { withCredentials: true });
  } catch (err) {
    return;
  }
};

export const messageRead = async (messageId) => {
  const api = process.env.REACT_APP_API_URL + "/adm/message/read/" + messageId;
  try {
    await axios.post(api, {}, { withCredentials: true }); //no body needed
  } catch (err) {
    return;
  }
};
